import dayjs, { Dayjs } from "dayjs";
import { PropertyDisplayFormat } from "../../Models/PropertyDisplayFormat";
import { stripPhoneNumber } from "./phoneNumberFormatting";

/**
 * Checks if a property value has changed from its original value
 * Takes into account the property format for proper comparison
 */
export default function hasPropertyValueChanged(
  currentValue: string | Dayjs | number | null,
  originalValue: string | Dayjs | number | null,
  format?: PropertyDisplayFormat
): boolean {
  // Check for Date or DateTime formats - use Dayjs comparison
  if (format === PropertyDisplayFormat.Date || format === PropertyDisplayFormat.DateTime) {
    if (dayjs.isDayjs(currentValue)) {
      return !currentValue.isSame(originalValue);
    }
  }

  if (format === PropertyDisplayFormat.PhoneLink) {
    return stripPhoneNumber(currentValue) !== stripPhoneNumber(originalValue);
  }

  // For all other formats (including Currency), use standard comparison
  return currentValue !== originalValue;
}
